export default __webpack_public_path__ + "2d0a29d8cada1bdf2153890135f938d5.png";